module.exports = __webpack_public_path__ + "static/img/hos-thumb.7de75a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/pjmove-thumbs/hos-thumb.jpg
// module id = maHN
// module chunks = 0